export default {
  sections: {
    title: {
      title: 'Comandă confirmată',
      description: 'Cardul cadou a fost achiziționat cu succes',
    },
    instructions: {
      title: 'Verifică e-mailul',
      description:
        'Am trimis detaliile cardului cadou și chitanța la adresa ta de e-mail. Codul va sosi în 5-10 minute.',
    },
    details: {
      total: 'Total',
      order_number: 'Număr comandă',
    },
    footer: {
      help: 'Partenerul nostru tehnologic Foodamigos ne ajută să gestionăm cardurile cadou. Dacă nu primești cardul cadou sau nu îl găsești, contactează-i la {{email}}',
      questions: 'Dacă ai întrebări generale despre răscumpărare, contactează-ne direct la {{email}}',
    },
  },
  buttons: {
    go_home: 'Înapoi acasă',
    download_pdfs: 'Descarcă PDF card cadou',
  },
};
